// src/utils/getBrowserType.js
export function getBrowserType() {
    const ua = navigator.userAgent;
    if (/CriOS/i.test(ua)) return 'Chrome';
    if (/FxiOS/i.test(ua)) return 'Firefox';
    if (/EdgiOS|EdgA?iOS/i.test(ua)) return 'Edge';
    if (/OPiOS|Opera/i.test(ua)) return 'Opera';
    if (/Safari/i.test(ua) && /Mobile/i.test(ua)) return 'Safari';
    if (/Chrome/i.test(ua)) return 'Chrome';
    if (/Edg/i.test(ua)) return 'Edge';
    if (/Firefox/i.test(ua)) return 'Firefox';
    if (/Safari/i.test(ua)) return 'Safari';
    if (/Opera|OPR/i.test(ua)) return 'Opera';
    return 'Other';
}
